import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import type { Role } from '../lib/types';

/**
 * Gate for the signed-in area. A user carrying a temporary password is pushed
 * to the change-password screen before anything else loads.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, mustChangePassword, endReason } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <FullPageLoader />;
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname, idle: endReason === 'idle' }} />;
  }
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}

export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export function FullPageLoader() {
  return (
    <div className="spark-splash-screen">
      <div className="spark-splash-screen__content">
        <p style={{ color: '#fff', fontSize: 18 }}>Loading your workspace…</p>
      </div>
    </div>
  );
}
